export default "__VITE_ASSET__BfU9Xdfl__"